import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment/moment';
import React from 'react';

import DataGrid from '#app/Component/DataGrid';
import IconAction from '#app/Component/IconAction';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { transformObjectToDataGridRowsArray } from '#app/Util/DataGridDataTransformer';
import useDisputes from '#app/View/Sale/Client/SaleClient/hooks/useDisputes';
import {
  DisputeState,
  DisputeStateTranslations,
  DisputeType,
  DisputeTypeTranslations,
} from '#app/typings/orderClientLitige';
import { DisputeListByClient } from '#app/typings/orderClientLitige';

const DisputeList: React.FC = () => {
  const { disputes, loading } = useDisputes();

  const columns: GridColDef[] = [
    {
      field: 'ref',
      headerName: 'Référence',
      minWidth: 280,
    },
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 200,
      flex: 1,
      valueGetter: (value: DisputeType) => DisputeTypeTranslations[value],
    },
    {
      field: 'state',
      headerName: 'Statut',
      minWidth: 150,
      valueGetter: (value: DisputeState) => DisputeStateTranslations[value],
    },
    {
      field: 'reason',
      headerName: 'Raison',
      flex: 1,
    },
    {
      field: 'author',
      headerName: 'Auteur',
      minWidth: 170,
      valueGetter: (_, row: DisputeListByClient) => row.authorLitige?.name,
    },
    {
      field: 'litigeAt',
      headerName: 'Date de création',
      minWidth: 150,
      valueGetter: (value) => moment(value).format('lll'),
    },
    {
      field: 'dealAt',
      headerName: 'Date de cloture',
      minWidth: 150,
      valueGetter: (value) => (value ? moment(value).format('lll') : '-'),
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'actions',
      getActions: ({ row }) => [
        <IconAction
          title="Visualiser"
          icon="view"
          to={getRoutePathname('client_service_order_client_litige', { uuid: row.uuid })}
        />,
      ],
    },
  ];

  return (
    <DataGrid loading={loading} columns={columns} rows={transformObjectToDataGridRowsArray(disputes)} hideFooter />
  );
};

export default DisputeList;
